__turbopack_context__.v({
  "error-msg": "ReferralForm-module-scss-module__876rpG__error-msg",
  "form": "ReferralForm-module-scss-module__876rpG__form",
  "form-field": "ReferralForm-module-scss-module__876rpG__form-field",
  "link-card-share": "ReferralForm-module-scss-module__876rpG__link-card-share",
  "share": "ReferralForm-module-scss-module__876rpG__share",
  "share-btn": "ReferralForm-module-scss-module__876rpG__share-btn",
  "share-buttons": "ReferralForm-module-scss-module__876rpG__share-buttons",
});
